import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { ErrorToast } from 'utils/Toasts';

const GoogleError = () => {
  const navigate = useNavigate();
  const errorToastRef = useRef();

  useEffect(() => {
    errorToastRef.current?.showError(
      'Google prisijungimas nepavyko. Pabandykite dar kartą.',
    );
    setTimeout(() => {
      navigate('/prisijungimas');
    }, 3000);
  }, [navigate]);

  return <ErrorToast ref={errorToastRef} />;
};

export default GoogleError;
